import { render, staticRenderFns } from "./MemberVisit.vue?vue&type=template&id=96a4f0e8&"
import script from "./MemberVisit.vue?vue&type=script&lang=js&"
export * from "./MemberVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports